<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ "bikeshop.menu.coupons" | translate }}
</span>
    </div>
  </div>

  <div class="content">
    <div class="margin-top-8 filter-bar">
      <div class="add-new">
        <div pTooltip="{{ 'bikeshop.coupons.add_coupon' | translate }}"
             tooltipPosition="left" class="hubtiger-add pull-right" (click)="addCoupon()"></div>
      </div>
      <div class="search">
        <div class="p-inputgroup">
          <div style="width: 100%; float: left;">
            <daz-icon class=" icon-shift-12 iso-search-icon-service" [name]="'search'" [size]="'22px'"
                      [color]="'#888888'"></daz-icon>
            <input type="text" class="iso-search-bar-service" [(ngModel)]="search" placeholder="{{
              'bikeshop.coupons.search' | translate
            }}" (keydown)="inputChanged()" (ngModelChange)="search = $event.toUpperCase()"/>
          </div>
        </div>
      </div>
      <div>
        <p-checkbox [binary]="true" [(ngModel)]="showExpired"
                    label="{{ 'bikeshop.coupons.show_expired' | translate }}"
                    (onChange)="getCoupons()"></p-checkbox>
      </div>
    </div>

    <div class="flex" *ngIf="busy">
      <div style="margin-left: auto; margin-top: 16px">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                           animationDuration=".5s"></p-progressSpinner>
      </div>
    </div>

    <div class="no-coupons" *ngIf="!busy && totalRecords === 0 && search.length === 0">
      {{ 'bikeshop.coupons.no_coupons' | translate }}
    </div>

    <div class="no-coupons" *ngIf="!busy && totalRecords === 0 && search.length > 0">
      {{ 'bikeshop.coupons.search_empty_results' | translate }}
    </div>

    <div class="margin-top-16">
      <p-table #couponsTable [columns]="columns" [value]="coupons">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns"
                [ngStyle]="{'width': col.field === 'couponCode' ? '165px' : 'auto'}">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-coupon let-columns="columns">
          <tr [pSelectableRow]="coupon" (click)="editCoupon(coupon)"
              [ngClass]="{'expired' : coupon['expired']}">
            <td *ngFor="let col of columns" [ngClass]="{'bold' : col.field === 'couponCode'}">
              <div>
                {{
                col.type === 'redeemMethod' && coupon[col.field] === 'ANY' ? ('bikeshop.coupons.any_platform' | translate) : col.type === 'redeemMethod' && coupon[col.field] === 'APP' ? ('bikeshop.coupons.app' | translate) : col.type === 'redeemMethod' && coupon[col.field] === 'WIDGET' ? ('bikeshop.coupons.online_widget' | translate) :
                  col.type === 'type' && coupon[col.field] === 'PERCENT' ? ('bikeshop.coupons.percent' | translate) : col.type === 'type' && coupon[col.field] === 'FIXED_VALUE' ? ('bikeshop.coupons.fixed_value' | translate) :
                    col.type === 'value-type' ? (coupon['type'] === 'PERCENT' ? (coupon['percentValue'] + '%') : (partner.CurrencySymbol + coupon['fixedValue'])) :
                      col.type === 'boolean' && coupon[col.field] === true ? ('general.yes' | translate) : col.type === 'boolean' && coupon[col.field] === false ? ('general.no' | translate) :
                        col.type === 'date' ? (coupon[col.field] === null ? '-' : (coupon[col.field] | date : countryData.AngularDateFormat)) :
                          col.type === 'redemptions' ? (coupon['timesUsed'] + (coupon['usageTimes'] > 0 ? (' / ' + coupon['usageTimes']) : '')) :
                            col.type === 'linked' ? coupon['linkedItems'] :
                              coupon[col.field]
                }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-paginator [rows]="limit" [totalRecords]="totalRecords" (onPageChange)="paginate($event)"></p-paginator>
    </div>
  </div>
</div>

<p-sidebar #NavSideBar [(visible)]="showCouponDetail" position="right"
           [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="getCoupons(); NavSideBar.destroyModal()">
  <div *ngIf="showCouponDetail">
    <app-coupon-detail [coupon]="selectedCoupon" (close)="closeCouponDetail()" [isRentals]="isRentals"
                       [isWorkshop]="isWorkshop"></app-coupon-detail>
  </div>
</p-sidebar>

<p-toast position="bottom-right" key="coupon-toast"></p-toast>
